import axios from 'axios';
import get from 'lodash/get';
//! PLOP_APPEND_SERVICE

export async function fetchActiveUser() {
  return axios.post('/reservations/v1/active-user').then((res) => res.data);
}

export async function checkId({ idNumber }) {
  return axios.post('/auth/v1/validate-id', { idNumber });
}

export async function login({ idNumber, email }) {
  return axios.post('/reservations/v1/login', { idNumber, email });
}

export async function handleTwoFactor(data) {
  return axios.post('/reservations/v1/mfa', data);
}

export async function updateUserFields(fields) {
  return axios.post('/auth/v1/sg-signup', fields);
}
